<script>
  import { timeFormat } from 'd3-time-format'
  let formatTime = timeFormat('%e %B %Y')

  let promise = false
  let cases = []
  let gpScale = []
  import MiniCharts from './components/MiniCharts.svelte'
  let provs = ['gp', 'wc', 'kzn', 'mp', 'nc', 'nw', 'ec', 'fs', 'lp']

  let dateCount = -60

  import { onMount } from 'svelte'
  import * as d3 from 'd3'
  import { parseTime } from './functions.js'

  let data = []
  let width = 150
  let height = width * 0.5
  async function getData() {
    await fetch(
      'https://mediahack.co.za/datastories/coronavirus/data/provinces.php'
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
        response.forEach((d) => {
          d.daily_cases = +d.daily_cases
          d.date = parseTime(d.date)
          if (d.daily_cases < 0) {
            d.daily_cases = 0
          }
        })
        data = response
        cases.ec = data.filter((d) => d.province_id === 'EC').slice(dateCount)
        cases.gp = data.filter((d) => d.province_id === 'GP').slice(dateCount)
        gpScale = cases.gp
        cases.fs = data.filter((d) => d.province_id === 'FS').slice(dateCount)
        cases.kzn = data.filter((d) => d.province_id === 'KZN').slice(dateCount)
        cases.wc = data.filter((d) => d.province_id === 'WC').slice(dateCount)
        cases.nc = data.filter((d) => d.province_id === 'NC').slice(dateCount)
        cases.lp = data.filter((d) => d.province_id === 'LP').slice(dateCount)
        cases.mp = data.filter((d) => d.province_id === 'MP').slice(dateCount)
        cases.nw = data.filter((d) => d.province_id === 'NW').slice(dateCount)
      })
  }

  $: scaleX = d3
    .scaleTime()
    .domain(d3.extent(gpScale, (d) => d.date))
    .range([10, width - 10])

  $: scaleY = d3
    .scaleLinear()
    .domain([10, d3.max(gpScale, (d) => d.daily_cases) * 1.1])
    .range([height, 0])

  $: xTicks = scaleX.ticks(4)
  $: yTicks = scaleY.ticks(4)

  onMount(() => {
    getData().then(() => {
      width = document.querySelector('.chart').clientWidth
      height = width * 0.5

      promise = true
    })
  })
</script>

<div class="chart-title">Daily Cases in each province</div>
{#if promise}
  <div class="updated">
    Updated {formatTime(cases.ec[cases.ec.length - 1].date)}
  </div>
{/if}
<div class="charts province-chart">
  <div class="charts-wrap">
    {#each provs as p}
      <div class="chart">
        {#if promise}
          <MiniCharts
            {height}
            {width}
            cases={cases[p]}
            {scaleX}
            {scaleY}
            {xTicks}
            {yTicks}
            prov={p}
          />
        {/if}
      </div>
    {/each}
  </div>
</div>

<style>
  .charts {
    width: 100%;
    margin-top: 20px;
  }
  .charts-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }

  .chart {
    width: 100%;
    aspect-ratio: 16/9;
    border: solid 1px #cccccc;
    padding-bottom: 15px;
    background: rgb(246, 246, 246);
  }

  @media only screen and (max-width: 600px) {
    .charts-wrap {
      grid-template-columns: 1fr 1fr;
    }
  }
</style>
